export const TITLE_MODAL = 'Edit participant details';
export const EDIT_TEXT = 'Edit';
